(() => {
  'use strict';

  const PRODUCT_INFO_SELECTOR = '[id^="ProductInfo-"]';
  const PREORDER_SELECTOR = '[data-edelman-preorder="true"]';
  const HIDDEN_CLASS = 'edelman-preorder-duplicate-copy';

  const duplicatePatterns = [
    'we will order all the parts',
    'build your dream watch as soon as possible',
    'this item is a deferred, subscription, or recurring purchase',
    'dit artikel is een terugkerende of uitgestelde aankoop',
    'dit is een terugkerende of uitgestelde aankoop',
    'opzeggingsbeleid',
    'totdat mijn bestelling is afgehandeld',
    'totdat ik, indien toegestaan, opzeg'
  ];

  const normalize = (value) => String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const hasInteractiveContent = (element) => Boolean(
    element.querySelector('button, input, select, textarea, [role="button"]')
  );

  const findSafeBlock = (textNode, root) => {
    let element = textNode.parentElement;
    let best = element;

    while (element && element !== root) {
      if (element.matches(PREORDER_SELECTOR) || element.closest(PREORDER_SELECTOR)) return null;
      if (['SECTION', 'PRODUCT-COMPONENT'].includes(element.tagName)) break;

      const text = normalize(element.textContent);
      if (!text || text.length > 1000 || hasInteractiveContent(element)) break;

      best = element;
      const parent = element.parentElement;
      if (!parent || parent === root || hasInteractiveContent(parent)) break;

      const parentText = normalize(parent.textContent);
      if (parentText.length > 1000 || parentText.length > text.length + 120) break;
      element = parent;
    }

    return best;
  };

  const hideDuplicateText = (root) => {
    if (!root.querySelector(PREORDER_SELECTOR)) return;

    // Shopify's standard payment-terms form and app-generated legal copy aren't
    // useful next to Edelman's single, clear preorder message.
    root.querySelectorAll('form.installment').forEach((form) => {
      form.closest('div')?.classList.add(HIDDEN_CLASS);
      form.classList.add(HIDDEN_CLASS);
    });

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const matches = [];
    let node;

    while ((node = walker.nextNode())) {
      if (!node.parentElement || node.parentElement.closest(PREORDER_SELECTOR)) continue;
      const text = normalize(node.nodeValue);
      if (text && duplicatePatterns.some((pattern) => text.includes(pattern))) {
        matches.push(node);
      }
    }

    matches.forEach((textNode) => {
      const block = findSafeBlock(textNode, root);
      if (block) {
        block.classList.add(HIDDEN_CLASS);
        block.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const cleanAllProductInfo = () => {
    document.querySelectorAll(PRODUCT_INFO_SELECTOR).forEach(hideDuplicateText);
  };

  const start = () => {
    const observedRoots = new WeakSet();
    const productObserver = new MutationObserver(() => cleanAllProductInfo());

    const observeProductRoots = () => {
      document.querySelectorAll(PRODUCT_INFO_SELECTOR).forEach((root) => {
        if (!observedRoots.has(root)) {
          observedRoots.add(root);
          productObserver.observe(root, { childList: true, subtree: true });
        }
      });
      cleanAllProductInfo();
    };

    observeProductRoots();

    const pageObserver = new MutationObserver(observeProductRoots);
    pageObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('variant:change', observeProductRoots);
    document.addEventListener('shopify:section:load', observeProductRoots);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
